import { AddressImg, EnvelopeIcon, FaxNumberIcon, TelephoneIcon } from '../../assets/icon';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AppState } from '../../core/store';
import { routePaths } from '../../core/navigation/route-paths';
import { DocumentTypeEnum } from '../../core/lib/constants';
// import QRCode from './qr-code';
import { isEmpty } from '../../core/lib/utils';

type Props = {
  pathName: string;
};

const Footer: React.FC<Props> = ({ pathName }) => {
  const { t } = useTranslation(['common']);

  const { globalData, documents } = useSelector((state: AppState) => state.common);

  useEffect(() => {
    setTimeout(() => {
      const loaderElement = document.querySelector('.container-loading');
      console.log('check element loading', loaderElement);
      if (loaderElement) {
        loaderElement?.remove();
      }
    }, 60000);
  }, []);

  const onDocumentPress = (key: DocumentTypeEnum) => {
    window.open(
      `${window.location.origin}/public/assets/documents/${
        documents.find((item) => item.feature.toUpperCase() === key.toUpperCase())?.feature
      }`,
    );
  };

  return (
    <footer id="footer" className={pathName === routePaths.Home ? 'bg-white' : 'bg-grey-footer'}>
      <div className="container pt-4">
        {!isEmpty(globalData.footerLogo?.url) ? (
          <img
            alt=""
            width="118"
            height="38"
            className="footer-logo"
            src={globalData.footerLogo?.url || ''}
            loading="lazy"
          />
        ) : (
          <div className="footer-logo" />
        )}
        <div className="row mt-4 main-txt-color-1">
          <div className="col-md-9">
            <b className="d-block d-md-none">{t('common.contact')}</b>
            <div className="links">
              <div className="mb-4 contact-info">
                <img alt="" className="mt-2" src={AddressImg} loading="lazy" />
                <p
                  className="txt-address"
                  dangerouslySetInnerHTML={{ __html: globalData.address1 }}
                />
              </div>
              <div className="mb-4 contact-info">
                <img alt="" className="mt-2" src={AddressImg} loading="lazy" />
                <p
                  className="txt-address"
                  dangerouslySetInnerHTML={{ __html: globalData.address2 }}
                />
              </div>
              <div className="mb-4 contact-info">
                <img alt="" className="mt-2" src={AddressImg} loading="lazy" />
                <p
                  className="txt-address"
                  dangerouslySetInnerHTML={{ __html: globalData.address3 }}
                />
              </div>
              <div className="mb-4 contact-info">
                <img alt="" src={EnvelopeIcon} loading="lazy" />
                <p className="txt-address">{globalData.email}</p>
              </div>
              <div className="mb-4 contact-info">
                <img alt="" src={TelephoneIcon} loading="lazy" />
                <p className="txt-address">{globalData.phone}</p>
              </div>
              {!isEmpty(globalData.faxNumber) && (
                <div className="contact-info">
                  <img alt="" src={FaxNumberIcon} loading="lazy" />
                  <p className="txt-address">{globalData.faxNumber}</p>
                </div>
              )}
            </div>
          </div>
          <div className="col-md-3 company-links">
            <b className="text-blue-custom txt-address">{t('common.company')}</b>
            <ul className="links">
              <li className="txt-address text-blue-custom">
                <Link to="about-us">{t('common.about_us')}</Link>
              </li>
              {/* <li>
                <Link to="about-us#our-mission-and-vision">{t('common.our_mission')}</Link>
              </li>
              <li>
                <Link to="about-us#our-technology">{t('common.our_technology')}</Link>
              </li> */}
              <li className="txt-address text-blue-custom">
                <Link to="about-us#our-team">{t('common.our_team')}</Link>
              </li>
              <li className="txt-address text-blue-custom">
                <div
                  // target="_blank"
                  // href={getDocumentUrl(DocumentTypeEnum.PrivacyPolicy)}
                  // rel="noreferrer"
                  className="cursor-pointer"
                  onClick={() => onDocumentPress(DocumentTypeEnum.PrivacyPolicy)}
                >
                  {t('common.privacy_policy')}
                </div>
              </li>

              <li className="txt-address text-blue-custom">
                <div
                  // target="_blank"
                  // href={getDocumentUrl(DocumentTypeEnum.TermsOfSservice)}
                  // rel="noreferrer"
                  className="cursor-pointer"
                  onClick={() => onDocumentPress(DocumentTypeEnum.TermsOfSservice)}
                >
                  {t('common.terms_conditions')}
                </div>
              </li>
              <li className="txt-address text-blue-custom">
                <a
                  // target="_blank"
                  // href={getDocumentUrl(DocumentTypeEnum.TermsOfSservice)}
                  href={`${routePaths.Policies}`}
                  rel="noreferrer"
                >
                  {t('common.policiesTermsAndAgreements')}
                </a>
              </li>
              <li className="txt-address text-blue-custom">
                <Link to="contact-us">{t('common.contact_us')}</Link>
              </li>
            </ul>
          </div>
          {/* <div className="col-md-4 text-center">
            <QRCode />
          </div> */}
        </div>
      </div>
      <div className="container">
        <div className="home-bottom-line" style={{ marginTop: '3rem' }} />
      </div>
      <div
        className={
          pathName === routePaths.Home
            ? 'page-footer bg-white text-dark-custom'
            : 'bg-grey-footer page-footer text-dark-custom'
        }
      >
        <div className="container">
          {globalData.footerCopyright}
          <div className="social-icons">
            <span className="txt-address">{t('common.connect_with_us')}</span>
            <a
              href={globalData.twitter}
              rel="noreferrer"
              target={'_blank'}
              style={{ background: 'transparent' }}
            >
              <i className="fa fa-lg fa fa-twitter" />
            </a>
            <a
              href={globalData.linkedin}
              rel="noreferrer"
              target={'_blank'}
              style={{ background: 'transparent' }}
            >
              <i className="fa fa-lg fa fa-linkedin" />
            </a>
          </div>
        </div>
      </div>
      <Helmet>
        <script type="text/javascript">
          {`
            $('footer b').click(function(){
                let className = 'display';
                let currentGroup = $(this).parent();
                let isOpenning = currentGroup.hasClass(className);

                $('footer .links').each(function(){
                    $(this).parent().removeClass(className);
                });

                isOpenning ?
                    currentGroup.removeClass(className) :
                    currentGroup.toggleClass(className);
            });
`}
        </script>
      </Helmet>
    </footer>
  );
};

export default React.memo(Footer);
